import { Observable } from 'rxjs';
import { GenericService } from './../../generic.service';
import { Injectable } from '@angular/core';
import { Institute } from '../../../models/institute/randomInstituteResponse';
import { MyInstituteRequest } from '../../../models/institute/myInstituteRequest';

@Injectable({
  providedIn: 'root'
})
export class MyInstituteService {

  constructor(private genericService: GenericService) { }

  addMyInstitute(instituteId: string) {
    return this.genericService.post(`myinstitute/${instituteId}`, null);
  }
  addMyInstituteByRequestModel(req: MyInstituteRequest) {
    return this.genericService.post(`myinstitute`, req);
  }

  removeMyInstitute(instituteid: string, studentid: string) {
    return this.genericService.delete(`myinstitute/${instituteid}/delete/${studentid}`);
  }
  // removeMyInstitute(req: DeleteMyInstituteRequest)
  // {
  //   return this.genericService.delete(`myinstitute/delete`,);
  // }

  getMyInstitutes(): Observable<Institute[]> {
    return this.genericService.get(`myinstitutes`);
  }
  getMyInstitutesByid(studentid: string): Observable<Institute[]> {
    return this.genericService.get(`myinstitutes/${studentid}`);
  }


 updateMyInstitute(req: MyInstituteRequest, myInstituteId: number): Observable<any> {
    return this.genericService.put(`myinstitute/${myInstituteId}`, req);
}


// setmentorDeadline(studentId: string,studentInstituteId: number,mentorDeadline: string | null): Observable<any> {
//     return this.genericService.put(`mentor/students/${studentId}/institutes/${studentInstituteId}/deadline`,{mentorDeadline});
// } 

}
